module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sky-overlay-toggle",
    class: [{
      active: _vm.active
    }, _vm.name],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOverlay($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-2212ee5f"}!./scripts/sky-overlay/sky-overlay-toggle.html
// module id = 365
// module chunks = 1